var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "overlay" }, [
        _c("div", { staticClass: "overlay-toolbar" }, [
          _c(
            "div",
            { staticClass: "overlay-close", on: { click: _vm.closeOverlay } },
            [_vm._v("✕")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "overlay-content position-relative" }, [
          _c("div", { staticClass: "overlay-carousel" }, [
            _c(
              "div",
              {
                staticClass: "carousel slide",
                attrs: {
                  id: "overlayItemImageCarousel",
                  "data-touch": "false",
                  "data-interval": "false",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "position-relative mx-auto carousel-wrapper" },
                  [
                    _c(
                      "div",
                      { staticClass: "carousel-inner" },
                      _vm._l(_vm.previewImages, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: {
                              "carousel-item": true,
                              active: index === _vm.activeIndex,
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "img-fluid",
                              attrs: {
                                src: item,
                                alt: _vm.name,
                                loading: "lazy",
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "carousel-control carousel-control-prev",
                    attrs: {
                      "data-target": "#overlayItemImageCarousel",
                      "data-slide": "prev",
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M15 18L9 12L15 6",
                            stroke: "#121926",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "carousel-control carousel-control-next",
                    attrs: {
                      "data-target": "#overlayItemImageCarousel",
                      "data-slide": "next",
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M9 18L15 12L9 6",
                            stroke: "#121926",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-center px-3" }, [
          _vm._v(_vm._s(_vm.name)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "overlay-thumbnail-images" },
          _vm._l(_vm.carouselImages, function (image, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "thumbnail-image",
                class: { active: index === _vm.activeIndex },
                attrs: {
                  "data-target": "#overlayItemImageCarousel",
                  "data-slide-to": index,
                },
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: image, alt: _vm.name, loading: "lazy" },
                }),
              ]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }